import { Yup } from "components/DynamicForm/utils";
import { DELIVERY_ROUTE_STATUS, DELIVERY_ROUTE_STATUS_CODES, DUA_STATUS, DYNAMIC_TYPE_INPUT_TYPE, MOVEMENT_STATUS, SELECT_INPUT_TYPE, TRANSPORTAION_KEYS } from "utils/Constants";

const form = {
    sections: [{
        fields: [
            [
                {
                    "type": "text",
                    "name": "secuencia",
                    "label": "Secuencia",
                    "disabled": true,
                    "sizing": {
                        "sm": 4
                    }
                },
            ],
            [
                {
                    "type": "text",
                    "validation": Yup.string().required(),
                    "name": "delivery_man",
                    "label": "Repartidor"
                },
                {
                    "type": "date",
                    "name": "date",
                    "label": "Fecha de Ruta",
                    "sizing": {
                        "sm": 4
                    }
                },
            ],
            [
                {
                    "type": SELECT_INPUT_TYPE,
                    "name": "status",
                    "label": "Estado Ruta",
                    "validation": Yup.string().required(),
                    "options": DELIVERY_ROUTE_STATUS,
                    // "defaultValue": DELIVERY_ROUTE_STATUS_CODES.SCHEDULED,
                    "sizing": {
                        "sm": 4
                    }
                },
            ],
            [
                {
                    "type": "textarea",
                    "rows": "4",
                    "name": "comments",
                    "label": "Comentarios"
                }
            ],
        ]
    }]
};

export default form;